export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/clock.fe82d5dd.svg","height":12,"width":12,"blurWidth":0,"blurHeight":0};